import classImg01 from '../assets/class_img01.png';
import classImg02 from '../assets/class_img02.png';
import classImg03 from '../assets/class_img03.png';
import classImg04 from '../assets/class_img04.png';
import classImg05 from '../assets/class_img05.png';
import classImg06 from '../assets/class_img06.png';

export const classImageList: Record<string, string> = {
  AI동화체험: classImg01,
  AI음악체험: classImg02,
  숫자나라: classImg03,
  호기심나라: classImg04,
  글쓰기나라: classImg05,
  그림나라: classImg06
};
